import { css } from "styled-components/native";

export const textMixin = css`
  color: #000;
  font-weight: bold;
`;
